module.exports = __webpack_public_path__ + "static/media/062-namibia.9ccd90a3.svg";